import { Box, Button } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import Config from 'src/common/Config';
import TabHeader from './TabHeader';

export default function PasswordManagement() {
  const orySettingsUrl = Config.getOrySettingsUrl();

  return (
    <Box>
      <TabHeader
        title="Password & Security"
        subtitle="Manage your password, email, and multi-factor authentication."
      />

      <Button
        component="a"
        href={orySettingsUrl}
        target="_blank"
        rel="noopener noreferrer"
        leftSection={<IconExternalLink size={14} />}
        mt="md"
      >
        Manage Credentials on Secure Page
      </Button>
    </Box>
  );
}
